document.addEventListener('DOMContentLoaded', function ( event ) {

// Get the modal and the close button
  let modal = document.getElementById('teamMemberModal');
  let closeModal = document.getElementById('closeModal');

// Get all the links
  let viewProfileLinks = document.querySelectorAll('.view-profile');

  let simplebarInstance = null;

  function initSimpleBar() {
    const scrollContainer = document.getElementById('modalProfileText');
    if ( !scrollContainer ) {
      return;
    }

    if ( simplebarInstance ) {
      simplebarInstance.unMount();
      simplebarInstance = null;
    }

    simplebarInstance = new SimpleBar(scrollContainer, {
      autoHide        : false,
      scrollbarMinSize: 35,
      timeout         : 800,
      forceVisible    : true
    });

    scrollContainer.scrollTop = 0;

    setTimeout(() => {
      if ( simplebarInstance ) {
        simplebarInstance.recalculate();
      }
    }, 100);
  }

// Get the team member data when clicking
  viewProfileLinks.forEach(function ( link ) {
    link.addEventListener('click', function ( e ) {
      e.preventDefault();

      let teamMember = link.closest('.grid-item').querySelector('.team-member');
      let profileImage = teamMember.querySelector('.collection-image img').src;
      let name = teamMember.querySelector('h3').innerText;
      let title = teamMember.querySelector('.item_position').innerText;

      // Get the JSON string from the div
      let jsonString = teamMember.querySelector('.profile-text').innerText;

      function convertRichTextToHtml( node ) {
        if ( !node ) {
          return '';
        }

        switch ( node.type ) {
          case 'root':
            return node.children ? node.children.map(convertRichTextToHtml).join('') : '';
          case 'paragraph':
            return '<p>' + (node.children ? node.children.map(convertRichTextToHtml).join('') : '') + '</p>';
          case 'text':
            let val = node.value || '';
            if ( node.bold ) {
              val = '<strong>' + val + '</strong>';
            }
            if ( node.italic ) {
              val = '<em>' + val + '</em>';
            }
            return val;
          case 'list':
            const listTag = node.listType === 'ordered' ? 'ol' : 'ul';
            return '<' + listTag + '>' + (node.children ? node.children.map(convertRichTextToHtml).join('') : '') + '</' + listTag + '>';
          case 'list-item':
            return '<li>' + (node.children ? node.children.map(convertRichTextToHtml).join('') : '') + '</li>';
          case 'heading':
            const level = node.level || 1;
            return '<h' + level + '>' + (node.children ? node.children.map(convertRichTextToHtml).join('') : '') + '</h' + level + '>';
          case 'link':
            return '<a href="' + node.url + '" target="' + (node.target || '_self') + '">' + (node.children ? node.children.map(convertRichTextToHtml).join('') : '') + '</a>';
          default:
            return node.children ? node.children.map(convertRichTextToHtml).join('') : (node.value || '');
        }
      }

      let profileText = '';
      try {
        let jsonObject;
        try {
          jsonObject = JSON.parse(jsonString);
        }
        catch ( e ) {
          let decodedJsonString = new DOMParser().parseFromString(jsonString, 'text/html').body.innerText;
          jsonObject = JSON.parse(decodedJsonString);
        }
        profileText = convertRichTextToHtml(jsonObject);
      }
      catch ( e ) {
        console.error('Error parsing profile JSON:', e);
        profileText = jsonString;
      }

      let
        email           = teamMember.querySelector('.item_email').innerHTML,
        telephone       = teamMember.querySelector('.item_telephone').innerHTML,
        contactLinkHTML = teamMember.querySelector('.item_contact-link').innerHTML;

      // Set modal content
      document.getElementById('modalProfileImage').src = profileImage;
      document.getElementById('modalName').innerText = name;
      document.getElementById('modalTitle').innerText = title;
      document.getElementById('modalProfileText').innerHTML = profileText;

      // Reset dynamic content, so data from previous modals doesn't leak in:
      document.getElementById('modalEmail').innerHTML = '';
      document.getElementById('modalTelephone').innerHTML = '';
      document.getElementById('modalContactLink').innerHTML = '';

      if ( email != '' ) {
        document.getElementById('modalEmail').innerHTML = email;
      }
      if ( telephone != '' ) {
        document.getElementById('modalTelephone').innerHTML = telephone;
        document.getElementById('modalTelephone').classList.remove('hidden');
      }
      else {
        document.getElementById('modalTelephone').classList.add('hidden');
      }
      if ( contactLinkHTML != '' ) {
        document.getElementById('modalContactLink').innerHTML = contactLinkHTML;
      }

      // Show the modal
      modal.style.display = 'block';

      setTimeout(initSimpleBar, 50);
    });
  });

// Close the modal
  closeModal.addEventListener('click', function () {
    modal.style.display = 'none';

    if ( simplebarInstance ) {
      simplebarInstance.unMount();
      simplebarInstance = null;
    }
  });

  window.addEventListener('click', function ( e ) {
    if ( e.target == modal ) {
      modal.style.display = 'none';
      if ( simplebarInstance ) {
        simplebarInstance.unMount();
        simplebarInstance = null;
      }
    }
  });
});
